<script>
import { Line } from 'vue-chartjs';

export default {
  extends: Line,
  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart({
      labels: ['فروردین',
        'اردیبهشت',
        'خرداد',
        'مهر',
        'آبان',
        'آذر',
        'دی',
        'بهمن',
        'اسفند'],
      datasets: [
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان فروش',
          backgroundColor: '#ffffff22',
          borderColor: '#ffffff',
          pointBackgroundColor: '#333333',
          pointBorderColor: '#ffffff',
          pointRadius: 2,
          borderWidth: 2,
          pointHitRadius: 2,
          data: [83, 217, 126, 240, 56, 34, 239, 85, 298],
        },
        {
          defaultFontFamily: 'Vazir FD',
          label: 'میزان پیشرفت',
          backgroundColor: '#ffffff22',
          borderColor: '#ffffff',
          pointBackgroundColor: '#333333',
          pointBorderColor: '#ffffff',
          pointRadius: 2,
          borderWidth: 2,
          pointHitRadius: 2,
          data: [100, 317, 326, 220, 156, 134, 219, 185, 198],
        },
      ],
    }, {
      defaultFontFamily: 'Vazir FD',
      responsive: true,
      maintainAspectRatio: false,
      fontColor: '#ffffff',
      aspectRatio: 1,
      scales: {
        tick: {
          fontFamily: 'Vazir FD',
          color: '#ffffff',
        },
        xAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0)',
            fontFamily: 'Vazir FD',
            drawBorder: true,
            zeroLineColor: '#ffcc3300',
          },
          label: {
            fontColor: '#ffffff',
          },
          ticks: {
            display: true,
            fontFamily: 'Vazir FD',
            fontSize: 10,
            fontColor: '#ffffff',
          },
        }],
        yAxes: [
          {
            gridLines: {
              color: '#ffffff11',
              drawBorder: true,
              zeroLineColor: '#ffffffaa',
              fontFamily: 'Vazir FD',
            },
            ticks: {
              fontFamily: 'Vazir FD',
              fontSize: 10,
              fontColor: '#ffffffcc',
              display: true,
            },
          }],
      },
      layout: {
        padding: 16,
      },
      legend: {
        display: true,
        fontSize: 10,
        labels: {
          fontColor: '#ffffff',
          fontFamily: 'Vazir FD',
          fontSize: 12,
        },
      },
    }, [

    ]);
  },
};
</script>

<style lang="scss" scoped>
canvas {
  height: 250px !important;
}
</style>
